export const ROUTES = {
  root: {
    index: '/',
    notFound: '/404',
  },
  public: {
    surveyForm: '/public/survey-form',
  },
  auth: {
    signin: '/login',
    forgotPassword: '/forgot-password',
    newPassword: '/new-password',
    twoFactor: '/two-factor',
    changePassword: '/change-password',
    resetPassword: '/reset-password',
  },
  admin: {
    reports: '/admin/reports-console',
    admins: {
      list: '/admin/admins',
      details: '/admin/admins/:id',
      create: '/admin/admins/create',
    },
    clients: {
      list: '/admin/clients',
      details: {
        settings: '/admin/clients/:id/settings',
        features: '/admin/clients/:id/features',
        deposits: {
          list: '/admin/clients/:id/deposits',
          history: '/admin/clients/:id/deposit-history',
        },
        transmissionActs: {
          list: '/admin/clients/:id/transmission-acts',
        },
        depositEvents: {
          list: '/admin/clients/:id/deposit-events',
        },
        expenses: {
          details: '/admin/clients/:id/expenses/:companyId',
        },
        administrators: {
          list: '/admin/clients/:id/administrators',
          details: '/admin/clients/:clientId/administrators/:adminId',
        },
        companies: {
          list: '/admin/clients/:id/companies',
          details: '/admin/clients/:id/companies/:companyId',
        },
      },
    },
    deposits: {
      balances: {
        companies: {
          list: '/admin/deposit-balances/companies',
        },
        clients: {
          list: '/admin/deposit-balances/clients',
        },
      },
    },
    brands: {
      list: '/admin/brands',
      settings: '/admin/brands/:id/settings',
      content: '/admin/brands/:id/content',
      cards: '/admin/brands/:id/cards',
      prompts: {
        list: '/admin/brands/prompts',
      },
    },
    cards: {
      list: '/admin/cards',
      settings: '/admin/cards/:id/settings',
      content: '/admin/cards/:id/content',
      price: '/admin/cards/:id/price',
      fees: '/admin/cards/:id/fees',
      vouchers: '/admin/cards/:id/vouchers',
    },
    orders: {
      list: '/admin/marketplace/orders',
      details: '/admin/marketplace/orders/:id',
    },
    discounts: {
      list: '/admin/discounts',
      reports: '/admin/discount-reports',
      details: {
        settings: '/admin/discounts/:id',
        codes: '/admin/discounts/:id/codes',
      },
      create: '/admin/discounts/create',
    },
    contentReviews: {
      list: '/admin/content-reviews',
      details: '/admin/content-reviews/:id',
    },
    terms: {
      list: '/admin/terms',
    },
    shopItems: {
      list: '/admin/marketplace/items',
      details: {
        settings: '/admin/marketplace/items/:id/settings',
        prices: '/admin/marketplace/items/:id/prices',
        content: '/admin/marketplace/items/:id/content',
        vouchers: '/admin/marketplace/items/:id/vouchers',
      },
    },
    shopUsers: {
      list: '/admin/shop/users',
      details: '/admin/shop/users/:id',
    },
    suppliers: {
      list: '/admin/marketplace/suppliers',
      details: '/admin/marketplace/suppliers/:id',
      partnerPortal: '/admin/marketplace/suppliers/:id/partner-portal',
      tracking: '/admin/marketplace/suppliers/:id/tracking',
    },
    benefitTemplates: {
      list: '/admin/benefit-templates',
      details: '/admin/benefit-templates/:id',
    },
    integrations: {
      list: '/admin/integration-types',
      details: '/admin/integration-types/:id',
    },
  },
  administrators: {
    details: '/administrators/:id',
  },
  companies: {
    details: '/companies/:id',
    create: '/companies/create',
  },
  transmissionActs: {
    list: '/transmission-acts',
  },
  shop: {
    external: {
      list: '/marketplace/deals',
    },
    internal: {
      items: {
        list: '/shop/internal/items',
        details: '/shop/internal/items/:id',
        create: '/shop/internal/items/create',
      },
      inventory: {
        list: '/shop/internal/inventory',
        details: '/shop/internal/inventory/:id',
      },
      settings: '/shop/internal/settings',
    },
  },
  brands: {
    list: '/brands',
  },
  discounts: {
    list: '/discounts',
    usage: '/discounts/usage',
  },
  orders: {
    list: '/marketplace/orders',
    internal: {
      details: '/orders/internal/:id',
    },
  },
  expenses: {
    list: '/expenses',
    external: {
      list: '/external-expenses',
    },
  },
  claims: {
    list: '/claims',
    settings: '/claims/settings',
    details: '/claim-details/:id',
  },
  employees: {
    list: '/employees',
    details: '/employees/:id',
  },
  employeeGroups: {
    list: '/groups',
    details: '/groups/:id',
  },
  benefits: {
    list: '/benefits',
    categories: {
      list: '/benefits/categories',
    },
    details: '/benefits/:id',
  },
  alternatives: {
    list: '/alternatives',
    details: '/alternatives/:id',
  },
  news: {
    list: '/news',
    details: '/news/:id',
    categories: {
      create: '/news/categories/create',
      details: '/news/categories/:id',
    },
  },
  recognitions: {
    list: '/recognition/list',
    settings: '/recognition/settings',
    achievements: {
      list: '/recognition/achievements/list',
      details: '/recognition/achievements/:id',
      create: '/recognition/achievements/create',
    },
    allocations: {
      list: '/recognition/allocations',
    },
    givers: {
      list: '/recognition/givers',
    },
    recipients: {
      list: '/recognition/recipients',
    },
    leaderboard: {
      list: '/recognition/leaderboard',
    },
    rewards: {
      list: '/recognition/rewards',
    },
    brands: {
      list: '/recognition/brands',
    },
    rules: {
      list: '/recognition/rules',
    },
    comments: {
      list: '/recognition/comments',
    },
  },
  trustBox: {
    list: '/trust-box',
  },
  surveys: {
    survey: {
      list: '/surveys/survey',
      details: '/surveys/survey/:id',
      results: '/surveys/survey/:id/results',
      submissions: {
        list: '/surveys/survey/:id/submissions',
        details: '/surveys/survey/:id/submissions/:submissionId',
        pending: {
          list: '/surveys/survey/:id/pending-submissions',
        },
      },
    },
    training: {
      list: '/surveys/training',
      details: '/surveys/training/:id',
      results: '/surveys/training/:id/results',
      submissions: {
        list: '/surveys/training/:id/submissions',
        details: '/surveys/training/:id/submissions/:submissionId',
        pending: {
          list: '/surveys/training/:id/pending-submissions',
        },
      },
    },
    form: {
      list: '/surveys/form',
      details: '/surveys/form/:id',
      results: '/surveys/form/:id/results',
      submissions: {
        list: '/surveys/form/:id/submissions',
        details: '/surveys/form/:id/submissions/:submissionId',
        pending: {
          list: '/surveys/form/:id/pending-submissions',
        },
      },
    },
  },
  wallets: {
    list: '/wallet',
  },
  logs: {
    list: '/more/log',
  },
  integrations: {
    logEvents: '/more/company-settings/integrations/:id/log-events',
  },
  automations: {
    list: '/automations',
    details: '/automations/:id',
    create: '/automations/create',
  },
} as const;
